import type { Cta } from '@/typings/generic';
import { EditableComponentProps } from '@adobe/aem-react-editable-components';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

export const config = {
	emptyLabel: 'List Of Links',
	isEmpty: (props: EditableComponentProps & { ctas?: Cta[] }) => !props.ctas,
	resourceType: `${EnvVarsService.getVar('VITE_APP_ID')}/components/listoflinks`,
};
